import { ClipConfigProps, ClipStepsControlProps } from "../../clip-menu";
import { BoundaryToolProps } from "./define-boundary";

export const BoundaryComponent = (
  props: ClipConfigProps & ClipStepsControlProps & BoundaryToolProps
) => {
  return <p className="text-sm">Coming soon!</p>;
};
